export default __webpack_public_path__ + "static/media/kitchen4-afterE-1920w.0f85b01c.png";